import React, {Component} from 'react'
import PropType from 'prop-types'

class FilterStatus extends Component {
    _handleChangeStatus = e => {
        const {value} = e.target

        this.props.onChangeStatus(value)
    }

    render() {
        const {status} = this.props
        return (
            <div style={{padding: "0 15px"}}>
                <label>Status</label>
                <div className="form-group">
                    <select
                        className="form-control"
                        onChange={this._handleChangeStatus} value={status}>
                        <option value="all">All</option>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                        <option value="logout">Logout</option>
                        <option value="checkpoint">Checkpoint</option>
                        <option value="wrong_pass">Wrong pass</option>
                        <option value="disabled">Disabled</option>
                    </select>
                </div>
            </div>
        )
    }
}

FilterStatus.propTypes = {
    onChangeStatus: PropType.func.isRequired,
}

export default FilterStatus



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/workers/components/FilterStatus.js